import React from 'react'
import PropTypes from 'prop-types'

import { Link as RRLink } from 'react-router-dom'

import useCalendarTransition from 'common/use-calendar-transition'

export const Link = ({ highSchoolId, highSchoolName, ...rest }) => {
  const handleTransition = useCalendarTransition(highSchoolId, highSchoolName)
  return (
    <RRLink
      {...rest}
      onClick={handleTransition}
    />
  )
}

Link.propTypes = {
  highSchoolId: PropTypes.string,
  highSchoolName: PropTypes.string,
}
